<!-- 单选框 -->
<template>
  <div>
    <template v-if="mode === 'DESIGN'">
      <el-input v-if="!expanding" class="max-width  disabled-box" suffix-icon="el-icon-arrow-down" size="small" :placeholder="placeholder"></el-input>
      <el-radio-group v-model="_value" v-else class="radio-group-box disabled-box">
        <el-radio v-for="(op, index) in options" :key="index" :label="op">{{op}}</el-radio>
      </el-radio-group>
    </template>
    <template v-else>
      <template v-if="!readerMode || perm==='E'">
        <el-select v-if="!expanding" v-model="_value" size="small" :placeholder="placeholder" :disabled="perm==='R'">
          <el-option v-for="(op, index) in options" :key="index" :value="op" :label="op"></el-option>
        </el-select>
        <el-radio-group v-model="_value" v-else :disabled="perm==='R'" class="radio-group-box">
          <el-radio v-for="(op, index) in options" :key="index" :label="op">{{op}}</el-radio>
        </el-radio-group>
      </template>
      <template v-else>
        <div  class="form-item-text" v-text="_value"></div>
      </template>
    </template>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "SelectInput",
  components: {},
  props:{
    value:{
      type: String,
      default: null
    },
    placeholder:{
      type: String,
      default: '请选择选项'
    },
    expanding:{
      type: Boolean,
      default: false
    },
    options:{
      type: Array,
      default: () => {
        return []
      }
    },
    readerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.max-width{
  max-width: 208px;
}
.disabled-box{  
    margin-bottom: 8px;
  }
.radio-group-box{
 
  /deep/{
    .el-radio{
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }
}
</style>
